import StoryCard from './StoryCard'
import StoryCardLoading from './StoryCardLoading'

export {StoryCard, StoryCardLoading}
export default StoryCard
